import { Flex, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import icons from 'shared/icons';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { TInternationalCompanyGroup } from './useInternationalCompanyGroup';
import { useTranslation } from 'helpers/languages/translations';

interface IToolbarProps {
    table: TInternationalCompanyGroup['table'];
    isLoading: TInternationalCompanyGroup['isLoading'];
    isRetailersLoading: TInternationalCompanyGroup['isRetailersLoading'];
    handleOpenModal: TInternationalCompanyGroup['handleOpenModal'];
    setModalData: TInternationalCompanyGroup['setModalData'];
    emptyModalData: TInternationalCompanyGroup['emptyModalData'];
    isInternationalCompaniesLoading: TInternationalCompanyGroup['isInternationalCompaniesLoading'];
    internationalCompanies: TInternationalCompanyGroup['internationalCompanies'];
    readonly?: boolean;
}

const Toolbar = ({
    table,
    handleOpenModal,
    isLoading,
    isRetailersLoading,
    isInternationalCompaniesLoading,
    internationalCompanies,
    readonly
}: IToolbarProps) => {
    const { setGlobalFilter } = table;
    const PlusIcon = icons.plus;
    const translate = useTranslation();

    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <Tooltip
                label={
                    !internationalCompanies?.data?.length
                        ? (translate('icg.tooltip.no_international_cluster') as string)
                        : ''
                }
                aria-label="Add Alias"
                isDisabled={!!internationalCompanies?.data?.length}
                placement="top"
            >
                <IconButton
                    onClick={() => {
                        handleOpenModal('add');
                    }}
                    {...iconTableStyle}
                    aria-label="add alias"
                    isDisabled={
                        readonly ||
                        isLoading ||
                        isRetailersLoading ||
                        isInternationalCompaniesLoading ||
                        !internationalCompanies?.data?.length
                    }
                    size="sm"
                    icon={<Icon as={PlusIcon} />}
                />
            </Tooltip>
        </Flex>
    );
};

export default Toolbar;
